import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { me } from '../../api/auth'

export default function RequireAdmin ({ children }) {
  const [status, setStatus] = useState('loading')
  const location = useLocation()

  useEffect(() => {
    let active = true
    me()
      .then(() => { if (active) setStatus('ok') })
      .catch(() => { if (active) setStatus('denied') })
    return () => { active = false }
  }, [])

  if (status === 'loading') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (status === 'denied') {
    return <Navigate to='/admin/login' state={{ from: location }} replace />
  }

  return children
}
